import { render, staticRenderFns } from "./BaseTablePagination.vue?vue&type=template&id=48b1267a"
import script from "./BaseTablePagination.vue?vue&type=script&lang=js"
export * from "./BaseTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports